import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Stack,
    Breadcrumbs,
    Tabs,
    Tab,
    Backdrop,
    CircularProgress
} from "@mui/material";
import { Link } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import ScheduleIcon from '@mui/icons-material/Schedule';
import Dia from "./Dia";
import AgendaPreliminar from "./AgendaPreliminar";
import PropTypes from 'prop-types';
const live_events_service = require('../../helpers/live_events_service')

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{ width: '100%' }}
        >
            {value === index && <Box sx={{ paddingLeft: { xs: '0%', md: '5%', lg: '10%' }, paddingRight: { xs: '0%', md: '5%', lg: '10%' } }} >{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function Programa() {
    const [contador] = useState(0);
    const [programa, setPrograma] = useState([]);
    const [value, setValue] = React.useState(0);
    const [loading, setLoading] = useState(true);
    const [isProgramaEmpty, setIsProgramaEmpty] = useState(false); // 👈 nuevo estado

    useEffect(() => {
        live_events_service
            .getData(
                "/programa/view/" +
                process.env.REACT_APP_EVT
            )
            .then((response_programa) => {
                setLoading(false);
                const programaData = response_programa.data;
                const speakers = programaData?.response_database?.programa?.speakers;

                // Sin datos (null, undefined, {} o []): mostrar la agenda preliminar quemada
                if (!speakers || (Array.isArray(speakers) && speakers.length === 0)) {
                    setIsProgramaEmpty(true);
                } else {
                    setIsProgramaEmpty(false);
                    setPrograma(speakers);
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                setIsProgramaEmpty(true);
            });

    }, [contador]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const dia_1 = {
        title: null, segments: [
            { title: null, begin: 0, end: 13 },
        ]
    }

    const dia2 = {
        title: null, segments: [
            { title: null, begin: 14, end: 26 },
        ]
    }

    return (
        <Box style={{ backgroundImage: "url('https://escuela-bancaria.s3.us-east-2.amazonaws.com/e9f84203-6749-4522-8de4-ea87bce35801.png')", width: '100%', backgroundPosition: 'top', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', minHeight: '100vh' }}>
            <Stack spacing={5} alignItems='center' pt={3}>
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>

                <Breadcrumbs aria-label="breadcrumb">
                    <Link
                        underline="hover"
                        sx={{ display: 'flex', alignItems: 'center' }}
                        color="inherit"
                        to="/"
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        Inicio
                    </Link>
                    <Typography
                        sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                    >
                        <ScheduleIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        Programa
                    </Typography>
                </Breadcrumbs>

                {isProgramaEmpty ? (
                    <AgendaPreliminar />
                ) : (
                    <>
                        <Box sx={{ width: '100%' }}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                sx={{
                                    '& .MuiTabs-indicator': {
                                        backgroundColor: '#6E1414',
                                    },
                                    '& .Mui-selected': {
                                        color: '#6E1414 !important',
                                    },
                                }}
                                centered
                            >
                                <Tab {...a11yProps(0)} label="Día 1" />
                                <Tab {...a11yProps(1)} label="Día 2" />
                            </Tabs>
                        </Box>
                        <CustomTabPanel value={value} index={0}>
                            <Dia config={dia_1} programa={programa} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <Dia config={dia2} programa={programa} />
                        </CustomTabPanel>
                    </>
                )}
            </Stack>
        </Box>
    );
}